import { render, staticRenderFns } from "./CallLogByDurationPieChart.vue?vue&type=template&id=6e03cd05&scoped=true&"
import script from "./CallLogByDurationPieChart.vue?vue&type=script&lang=js&"
export * from "./CallLogByDurationPieChart.vue?vue&type=script&lang=js&"
import style0 from "./CallLogByDurationPieChart.vue?vue&type=style&index=0&id=6e03cd05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e03cd05",
  null
  
)

export default component.exports